import React, { useEffect, useState, useRef } from 'react';
import { ButtonLoading, SimpleDialog, Icons, NewLoading } from 'components';
import { Grid, Button } from '@mui/material';
import clsx from 'clsx';
import { useStyles } from './Style';

const ReportOfflineTransactionActions = ({
  menuList = [],
  onExport,
  loading,
  onclickListReports,
  setIsOpenTimeLineDg,
  customStyle = {},
  timeLineLength = 0,
}) => {
  //STATES//
  const [anchorEl, setAnchorEl] = useState(null);
  const [isShowMenu, setIsShowMenu] = useState(null);
  const [itemsMenu, setItemsMenu] = useState([]);
  const classes = useStyles();
  const menuRef = useRef(null);
  const menuBtnRef = useRef(null);
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (!loading) setAnchorEl(null);
  }, [loading]);

  useEffect(() => {
    convertData();
  }, [menuList]);

  const handleClickOutside = (e) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(e.target) &&
      !menuBtnRef.current.contains(e.target)
    ) {
      setIsShowMenu(null);
    }
  };

  const initializeResult = () => {
    const uniqueTypes = ['xls', 'csv', 'pdf'];
    const typeMap = {};
    uniqueTypes.forEach((type) => {
      typeMap[type] = [];
    });
    menuList.forEach((item) => {
      if (!typeMap[item.type]) {
        typeMap[item.type] = [];
      }
      typeMap[item.type].push(item);
    });

    return { typeMap };
  };

  const convertData = () => {
    const { typeMap } = initializeResult();
    const result = {};
    Object.keys(typeMap).forEach((key) => {
      result[key] = typeMap[key];
    });
    const filteredTypeMap = Object.fromEntries(
      Object.entries(result).filter(([key, value]) => value.length > 0),
    );
    setItemsMenu(Object.entries(filteredTypeMap));
  };

  const handleShowDialog = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClick = (event, item, type) => {
    setIsShowMenu(event);
    if (item?.length === 1) {
      const index = menuList.findIndex((obj) => obj.type === item[0].type);
      if (item[0] && onExport) {
        onExport(item[0], index);
      }
    }
  };

  const handleClose = (type, index) => {
    setIsShowMenu(null);
    if (type && onExport) {
      onExport(type, index);
    }
  };

  return (
    <React.Fragment>
      {/* <Grid className={classes.containerActions} md={2} xs={12} style={customStyle}> */}
      {/* <Grid className={classes.btnDoing} md={12} xs={12}> */}
      {timeLineLength && Number(timeLineLength) > 0 ? (
        <ButtonLoading
          variant="contained"
          onClick={() => setIsOpenTimeLineDg(true)}
          color="primary"
          className={classes.reciveBtnFirst}
          name={
            timeLineLength != 0
              ? `در حال آماده سازی فایل(${timeLineLength})`
              : 'در حال آماده سازی فایل'
          }
        />
      ) : null}
      {/* </Grid> */}
      {/* <Grid direction="column" md={12} xs={12}> */}
      <>
        <ButtonLoading
          variant="contained"
          onClick={handleShowDialog}
          startIcon={<Icons icon="ReceiveSquare" color="#fff" size="23" />}
          color="primary"
          name={'دریافت فایل خروجی'}
          aria-controls="simple-menu"
          aria-haspopup="true"
          className={classes.reciveBtnFirst}
        />

        <SimpleDialog
          fullWidth
          maxWidth="sm"
          customClass={'noneOverFlow'}
          open={anchorEl}
          icon={<Icons icon="OpenNewTab" color="#303DBF" size="20" />}
          title={'دریافت فایل خروجی'}
          onClose={() => setAnchorEl(null)}
          style={{ padding: '30px' }}
        >
          <Grid container alignItems="center">
            <div className={classes.mainContent}>
              <p className={classes.description}>
                کاربر گرامی جهت انتخاب نوع فایل خروجی، یکی از موارد زیر را انتخاب کنید:
              </p>
              <Grid
                item
                justifyContent={'space-between'}
                className={classes.gridColumn}
                ref={menuBtnRef}
              >
                {itemsMenu?.length !== 0 && (
                  <>
                    {Object.entries(itemsMenu)?.map(([key, value]) => (
                      <div key={key} className={classes.box}>
                        <Button
                          className={clsx(
                            classes.blockReport,
                            Boolean(isShowMenu === itemsMenu[key][0]) ? 'isopen' : '',
                          )}
                          ref={menuRef}
                          onClick={() =>
                            handleClick(itemsMenu[key][0], itemsMenu[key][1], isShowMenu)
                          }
                        >
                          {/* این کد به دلیل عدم نمایش تصویر پس از باندل به این شکل نوشته شده است */}
                          {itemsMenu[key][0].toLowerCase() == 'pdf' && (
                            <img
                              alt="icon download"
                              className={classes.icons}
                              src="./images/pdf.svg"
                            />
                          )}

                          {itemsMenu[key][0].toLowerCase() == 'csv' && (
                            <img
                              alt="icon download"
                              className={classes.icons}
                              src="./images/csv.svg"
                            />
                          )}

                          {itemsMenu[key][0].toLowerCase() == 'xls' && (
                            <img
                              alt="icon download"
                              className={classes.icons}
                              src="./images/xls.svg"
                            />
                          )}

                          <span>{itemsMenu[key][0]} </span>
                          {itemsMenu[key][1]?.length > 1 && (
                            <b
                              className={clsx(
                                classes.arrowList,
                                Boolean(isShowMenu === itemsMenu[key][0]) ? 'isopen' : '',
                              )}
                            >
                              <Icons icon="CaretDown" color="#303DBF" size="23" />
                            </b>
                          )}
                        </Button>

                        {itemsMenu[key][1]?.length > 1 && (
                          <div
                            className={classes.menu}
                            style={{
                              opacity: !Boolean(isShowMenu === itemsMenu[key][0]) ? '0' : '1',
                              visibility: !Boolean(isShowMenu === itemsMenu[key][0])
                                ? 'hidden'
                                : 'visible',
                            }}
                          >
                            <ul>
                              {itemsMenu[key][1].map((v, k) => (
                                <li
                                  className={classes.menuItem}
                                  onClick={() => handleClose(v, k)}
                                >
                                  <Icons
                                    icon="ReceiveSquare"
                                    color="#2B398E"
                                    size="23"
                                    className={classes.icons}
                                  />
                                  <span> {v.title}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    ))}
                  </>
                )}

                {loading && (
                  <div className={classes.loadingContent}>
                    <NewLoading />
                  </div>
                )}
              </Grid>
            </div>
          </Grid>
        </SimpleDialog>
      </>

      <ButtonLoading
        className={classes.reciveBtn}
        variant="contained"
        onClick={() => onclickListReports()}
        color="primary"
        name="لیست درخواست گزارشات"
      />
      {/* </Grid> */}
      {/* </Grid> */}
    </React.Fragment>
  );
};

export default ReportOfflineTransactionActions;
